import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Producto } from '../../../_models/producto';
import { ProductoDestinoService } from '../../../_services/producto-destino.service';
import { NavService } from '../../../_services/_nav.service';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { ProductoDestino } from '../../../_models/producto-destino';
import { ListaItem } from '../../../_models/lista-item';
import { Location } from '@angular/common';
import { ProductoSubdestinoService } from '../../../_services/producto-subdestino.service';
import { RequisitoRespaldo } from '../../../_models/requisito-respaldo';
import { ProductoSubdestinoMontoAliado } from '../../../_models/producto-subdestino-monto-aliado';
import { ProductoSubDestinos } from '../../../_models/producto-subDestinos';
import { ProductosSubdestinosActividadService } from '../../../_services/productos-subdestinos-actividad.service';
import { ProductosSubdestinosActividad } from '../../../_models/productos-subdestinos-actividad';
import { SolicitudUcPsCausalesDenegaciones } from '../../../_models/solicitud-uc-ps-causales-denegaciones';
import { Dialog } from 'primeng/dialog';
import { ProductoDestinoMonto } from '../../../_models/producto-destino-monto';
import { ProductosSubdestinosMontosActividad } from '../../../_models/productos-subdestinos-montos-actividad';
import { sleep } from '../../../utils/utilidades';

@Component( {
  selector: 'app-producto-destino',
  templateUrl: 'producto-destino.component.html'
} )

export class ProductoDestinoComponent implements OnInit {

  @Input() producto: Producto;
  @Input() verDetalle: false;
  @ViewChild('dialo') dialogo: Dialog;

  lisDestinos: SelectItem[] = [];
  lisDestinosTodos: ListaItem[] = [];
  carInformacionInicial = true;
  lisProductosDestinos: ProductoDestino[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  lisSubdestino: SelectItem[] = [];
  lisSubdestinoTodos: ListaItem[] = [];
  listActividadesTodas: ListaItem[] = [];
  listActividades: SelectItem[] = [];
  textoDetalle: string;
  detalle = false;
  tituloDetalle: string;
  lisProSubdestinoTodos: ProductoSubDestinos[] = [];
  listProductosSubDestinosActividad: ProductosSubdestinosActividad[] = [];
  detalleActividad: {
    actividadCorto: string,
    actividadRelacionada: string,
    verCompletoActividad: boolean
  };
  formActividades: FormGroup;
  subActividades = false;
  carActividades = false;
  mosActividades = false;
  regSeleccionado: ProductoDestino;
  lisSubDestinoActividad: SelectItem[] = [];
  colActividades: any[] = [];
  lisActividadesMostrar: ProductosSubdestinosActividad[] = [];
  errorIndicadores = false;


  constructor( private proDestinoServicio: ProductoDestinoService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService,
               private proSubdestinoService: ProductoSubdestinoService,
               private productoSubdestinoService: ProductoSubdestinoService,
               private productosSubdestinosActividadService: ProductosSubdestinosActividadService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'id', header: this.navServicio.buscarMensaje( 'LBL_ID' ), sort: false },
      { field: 'nombreDestinoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_DESTINO' ), sort: false },
      { field: 'subdestino', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_SUBDESTINOS' ), sort: false },
      { field: 'indicadorAnalizamos', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORANALIZAMOS' ), sort: false },
      { field: 'indicadorFlujoDigital', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORFLUJODIGITAL' ), sort: false }
    ];
    this.colActividades = [
      { field: 'subDestinoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_SUBDESTINOS' ), sort: false },
      { field: 'actividadRelacionada', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_ACTIVIDAD' ), sort: false }
    ];

    if ( !this.verDetalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
      this.colActividades.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }

    forkJoin( this.proDestinoServicio.listadoPorProducto( this.producto.idProducto ),
      this.lisServicio.getMasterDetails( 'ListasDestinosProductos' ),
      this.lisServicio.getMasterDetails( 'ListasSubDestinosProductos' ),
      this.lisServicio.getMasterDetails( 'ListasActividadesRelacionadas' ),
      this.proSubdestinoService.listadoPorProducto( this.producto.idProducto ), this.productosSubdestinosActividadService.listaProducto( this.producto.idProducto ) ).subscribe( ( [ lisProductosDestinos, lisDestinos, subdestino, listActividades, proSubdestino, productosSubDestinosActividad ] ) => {
      this.lisDestinosTodos = lisDestinos;
      this.lisSubdestinoTodos = subdestino;
      this.lisProductosDestinos = lisProductosDestinos;
      this.lisProSubdestinoTodos = proSubdestino;
      this.listActividadesTodas = listActividades;
      this.listProductosSubDestinosActividad = productosSubDestinosActividad;
      this.cargarFormulario();
      this.validarIndicadores();
      this.cargarFormularioActividades();
      this.cargarListadoDestinos();
      if ( this.lisProductosDestinos.length > 0 ) {
        this.cargarListado();
      } else {
        this.carInformacionInicial = false;
      }
    } );
  }

  validarIndicadores() {
    this.errorIndicadores = !this.f.indicadorAnalizamos.value && !this.f.indicadorFlujoDigital.value;
  }

  verificarExisteAmbos( idDestino: string ) {
    let exiAnalizamos = false;
    let exiDigital = false;
    this.lisProductosDestinos.forEach( e => {
      if ( e.idDestinoProducto === idDestino ) {
        if ( e.indicadorAnalizamos ) {
          exiAnalizamos = true;
        }
        if ( e.indicadorFlujoDigital ) {
          exiDigital = true;
        }
        if ( exiAnalizamos && exiDigital ) {
          return true;
        }
      }
    } );
    return ( exiAnalizamos && exiDigital );
  }

  cargarListadoDestinos() {
    this.lisDestinos = [];
    this.lisDestinosTodos.map( ( s: ListaItem ) => {
      if ( !this.verificarExisteAmbos( s.idLista ) ) {
        this.lisDestinos.push( { label: s.nombre, value: s.idLista } );
      }
    } );

    this.lisSubdestino = [];
    this.lisSubdestinoTodos.map( ( s: ListaItem ) => {
      this.lisSubdestino.push( { label: s.nombre, value: s.idLista } );
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idDestinos: [ [], [ Validators.required ] ],
      idSubdestino: [ [] ],
      indicadorAnalizamos: [ false ],
      indicadorFlujoDigital: [ false ]
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  verificarExiste(formDatos: any, idDestino: string) {
    return !!this.lisProductosDestinos.find(x => x.idDestinoProducto === idDestino && ((formDatos.indicadorFlujoDigital && x.indicadorFlujoDigital) || (formDatos.indicadorAnalizamos && x.indicadorAnalizamos)));
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && !this.errorIndicadores ) {
      this.guardando = true;
      const proDestinoCrear = this.formulario.value;
        const desAgregar = [];
        let sudAgregar = [];
        if ( proDestinoCrear.idDestinos ) {
          for ( let i = 0; i < proDestinoCrear.idDestinos.length; i++) {
            const s = proDestinoCrear.idDestinos[i];
            if (this.verificarExiste(proDestinoCrear, s)) {
              const destinoEncontro = this.lisDestinosTodos.find(x => x.idLista === s);
              this.navServicio.setMesage( 0, {
                severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_EXISTEAGREGADOINDICADORES' ) + (destinoEncontro ? destinoEncontro.nombre : '')
              } );
              this.guardando = false;
              return true;
            }
            const regAgregar = {
              idProducto: this.producto.idProducto,
              idDestinoProducto: s,
              indicadorHabilitado: true,
              indicadorAliado: false,
              indicadorAnalizamos: proDestinoCrear.indicadorAnalizamos,
              indicadorFlujoDigital: proDestinoCrear.indicadorFlujoDigital,
              idProductoDestino: null
            };
            desAgregar.push( regAgregar );
          }
        }
        let subDestino = '';
        if ( proDestinoCrear.idSubdestino ) {
          proDestinoCrear.idSubdestino.map( s => {
            const d = this.lisSubdestinoTodos.find( x => x.idLista === s );
            if ( subDestino ) {
              subDestino = subDestino + ', ' + d.nombre;
            } else {
              subDestino = d.nombre;
            }
          } );
        }

        if ( desAgregar.length > 0 ) {
          this.proDestinoServicio.bulk( desAgregar ).subscribe( destino => {
            destino.map( async (s: ProductoDestino) => {
              const d = this.lisDestinosTodos.find(x => x.idLista === s.idDestinoProducto);
              if (d) {
                s.nombreDestinoProducto = d.nombre;
              }
              if (subDestino.length > 45) {
                s.subDestinoCorto = subDestino.substring(0, 45);
                s.subDestino = subDestino;
                s.verCompleto = true;
              } else {
                s.subDestinoCorto = subDestino;
                s.subDestino = subDestino;
                s.verCompleto = false;
              }

              const listPd = await this.proDestinoServicio.listadoPorProducto(this.producto.idProducto).toPromise();

              this.lisProductosDestinos = [...listPd];
            } );
            sudAgregar = this.listaSubDestino( destino );
            if ( sudAgregar.length > 0 ) {
              this.proSubdestinoService.bulk( sudAgregar ).subscribe( async sub => {
                const lisActividadInhabilitar = [];
                sub.map( x => {
                  const existe = this.lisProSubdestinoTodos.find( s => s.idProductoSubDestino === x.idProductoSubDestino );
                  if ( !existe ) {
                    const item = this.lisSubdestinoTodos.find( y => y.idLista === x.idSubDestinoProducto );
                    x.subDestinoProducto = item ? item.nombre : null;
                    this.lisProSubdestinoTodos.push( x );
                  } else {
                    existe.indicadorHabilitado = x.indicadorHabilitado;
                    if ( !existe.indicadorHabilitado ) {
                      this.listProductosSubDestinosActividad.forEach( y => {
                        if ( y.indicadorHabilitado && y.idProductoSubDestino === existe.idProductoSubDestino ) {
                          y.indicadorHabilitado = false;
                          lisActividadInhabilitar.push( y );
                        }
                      } );
                    }
                  }
                } );
                if ( lisActividadInhabilitar.length > 0 ) {
                  await this.productosSubdestinosActividadService.bulk( lisActividadInhabilitar ).toPromise();
                }
                this.cargarListadoDestinos();
                // this.cargarListado();
                this.cargarFormulario();
                this.validarIndicadores();
                this.submitted = false;
                this.guardando = false;
                this.navServicio.setMesage( 1 );
              } );
            } else {
              this.cargarListadoDestinos();
              // this.formulario.reset();
              this.cargarFormulario();
              this.validarIndicadores();
              this.submitted = false;
              this.guardando = false;
              this.navServicio.setMesage( 1 );
            }
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        } else {
          this.navServicio.setMesage( 1 );
          this.guardando = false;
        }
    }
  }

  inhabilitar( proDestino: ProductoDestino ) {
    if ( this.producto.indicadorHabilitado && this.lisProductosDestinos.length == 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'destinos',
        accept: () => {
          this.carInformacionInicial = true;
          proDestino.indicadorHabilitado = false;
          this.proDestinoServicio.actualizar( proDestino ).subscribe( regActualizado => {
            const subDestino = this.lisProSubdestinoTodos.filter( sud => sud.idProductoDestino === regActualizado.idProductoDestino );
            subDestino.forEach( s => {
              s.indicadorHabilitado = false;
            } );
            this.productoSubdestinoService.bulk( subDestino ).subscribe( subdestinos => {
              const subDestinosActividad = [];
              subdestinos.forEach( s => {
                const filtroActDes = this.listProductosSubDestinosActividad.filter( act => act.idProductoSubDestino === s.idProductoSubDestino );
                filtroActDes.forEach( f => {
                  f.indicadorHabilitado = false;
                  subDestinosActividad.push( f );
                } );
              } );
              this.productosSubdestinosActividadService.bulk( subDestinosActividad ).subscribe( actRel => {
                const a = this.lisProductosDestinos.findIndex( x => x.idProductoDestino === proDestino.idProductoDestino );
                if ( a >= 0 ) {
                  this.lisProductosDestinos.splice( a, 1 );
                }
                this.cargarListadoDestinos();
                this.carInformacionInicial = false;
              } );
            } );

          } );
        },
        reject: () => {
        }
      } );
    }
  }

  regresar() {
    this.location.back();
  }

  listaSubDestino( destino: any ) {
    const proDestinoCrear = this.formulario.value;
    const sudAgregar = [];
    destino.map( ( s: ProductoDestino ) => {
      proDestinoCrear.idSubdestino.map( sud => {
        const regAgregar = {
          idProductoDestino: s.idProductoDestino,
          idSubDestinoProducto: sud,
          indicadorHabilitado: true,
        };
        sudAgregar.push( regAgregar );
      } );
    } );
    return sudAgregar;
  }

  cargarListado() {

    this.lisProductosDestinos.map( s => {
      if ( s.idProductoDestino ) {
        const lisSubDestino = this.lisProSubdestinoTodos.filter( sud => sud.idProductoDestino === s.idProductoDestino && sud.indicadorHabilitado );
        let subDestino = '';

        lisSubDestino.map( su => {
          if ( subDestino ) {
            subDestino = subDestino + ', ' + su.subDestinoProducto;
          } else {
            subDestino = su.subDestinoProducto;
          }
        } );


        if ( subDestino.length > 45 ) {
          s.subDestinoCorto = subDestino.substring( 0, 45 );
          s.subDestino = subDestino;
          s.verCompleto = true;
        } else {
          s.subDestinoCorto = subDestino;
          s.subDestino = subDestino;
          s.verCompleto = false;
        }
      }
      this.carInformacionInicial = false;
    } );

  }


  detalleTabla( row: ProductoDestino ) {
    this.tituloDetalle = this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_SUBDESTINOS' );
    this.textoDetalle = row.subDestino;
    this.detalle = true;
  }

  detalleTablaAct( row: ProductoDestino ) {
    this.tituloDetalle = this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_ACTIVIDAD' );
    this.textoDetalle = row.actividadRelacionada;
    this.detalle = true;
  }

  cargarFormularioActividades() {
    this.formActividades = this.fb.group( {
      idActividadRelacionada: [ [], [ Validators.required ] ],
      idSubdestino: [ null, [ Validators.required ] ]
    } );
  }

  verActividades( row: ProductoDestino ) {
    this.regSeleccionado = row;
    this.lisSubDestinoActividad = [];
    this.lisProSubdestinoTodos.forEach( e => {
      if ( e.indicadorHabilitado && e.idProductoDestino === this.regSeleccionado.idProductoDestino ) {
        this.lisSubDestinoActividad.push( { label: e.subDestinoProducto, value: e.idProductoSubDestino } );
      }
    } );
    this.cargarActividadesMostrar();
    this.mosActividades = true;
  }

  async guardarActividades() {
    this.subActividades = true;
    if ( !this.formActividades.valid ) {
      return;
    }
    this.carActividades = true;
    const formulario = this.formActividades.value;
    const listadoEnviar = [];
    const itemSubdestino = this.lisSubDestinoActividad.find( x => x.value === formulario.idSubdestino );
    formulario.idActividadRelacionada.forEach( e => {
      const existe = this.listProductosSubDestinosActividad.find( y => y.idProductoSubDestino === formulario.idSubdestino && y.idActividadRelacionada === e );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        listadoEnviar.push( existe );
      } else if ( !existe ) {
        const itemActividad = this.listActividades.find( m => m.value === e );
        const nueRegistro = {} as ProductosSubdestinosActividad;
        nueRegistro.idActividadRelacionada = e;
        nueRegistro.indicadorHabilitado = true;
        nueRegistro.idProductoSubDestino = formulario.idSubdestino;
        nueRegistro.subDestinoProducto = itemSubdestino ? itemSubdestino.label : null;
        nueRegistro.actividadRelacionada = itemActividad ? itemActividad.label : null;
        listadoEnviar.push( nueRegistro );
      }
    } );
    if ( listadoEnviar.length > 0 ) {
      const actualizado = await this.productosSubdestinosActividadService.bulk( listadoEnviar ).toPromise();
      listadoEnviar.forEach( e => {
        if ( !e.idProductoSubDestinoActividad ) {
          const reg = actualizado.find( m => m.idActividadRelacionada === e.idActividadRelacionada );
          if ( reg ) {
            e.idProductoSubDestinoActividad = reg.idProductoSubDestinoActividad;
            this.listProductosSubDestinosActividad.push( e );
          }
        }
      } );
    }
    this.cargarActividadesMostrar();
    this.navServicio.setMesage( 2 );
    this.reiniciarActividades();
    this.centrarDialogo();
  }

  async centrarDialogo() {
    await sleep( 50 );
    this.dialogo.center();
  }

  cargarActividades( idSubdestino: string ) {
    this.listActividades = [];
    this.listActividadesTodas.forEach( e => {
      if ( !this.listProductosSubDestinosActividad.find( y => y.indicadorHabilitado && y.idProductoSubDestino === idSubdestino && y.idActividadRelacionada === e.idLista ) ) {
        this.listActividades.push( { label: e.nombre, value: e.idLista } );
      }
    } );

    if ( this.fAct.idActividadRelacionada.value && this.fAct.idActividadRelacionada.value.length > 0 ) {
      const lisAsignar = this.fAct.idActividadRelacionada.value.filter( x => !!this.listActividades.find( y => y.value === x ) );
      this.fAct.idActividadRelacionada.setValue( lisAsignar );
    }
  }

  cargarActividadesMostrar() {
    this.lisActividadesMostrar = this.listProductosSubDestinosActividad.filter( x => x.indicadorHabilitado && !!this.lisSubDestinoActividad.find( m => m.value === x.idProductoSubDestino ) );
  }

  cerrarModal() {
    this.mosActividades = false;
    this.reiniciarActividades();
    this.regSeleccionado = null;
    this.lisSubDestinoActividad = [];
  }

  reiniciarActividades() {
    this.formActividades.reset();
    this.listActividades = [];
    this.subActividades = false;
    this.carActividades = false;
  }

  get fAct() {
    return this.formActividades.controls;
  }

  inhabilitarActividad( row: ProductosSubdestinosActividad ) {
    this.carActividades = true;
    row.indicadorHabilitado = false;
    this.productosSubdestinosActividadService.actualizarSubDestinosActividad( row ).subscribe( r => {
      this.cargarActividadesMostrar();
      if ( this.fAct.idSubdestino.value ) {
        this.cargarActividades( this.fAct.idSubdestino.value );
      }
      this.navServicio.setMesage( 2 );
      this.carActividades = false;
    } );
  }


}
